import { PaymentStatusEnum } from "../store/config/enums";
import { TransactionCallbackResponse } from "../store/config/types";

const delayedNonCardPaymentMethodIds = new Set(["redpagos", "abitab", "pago-despues"]);

const normalizePaymentMethodId = (paymentMethodId?: string | null): string => {
  return (paymentMethodId ?? "").trim().toLowerCase();
};

const isDelayedNonCardMethod = (callbackResponse: TransactionCallbackResponse): boolean => {
  if (callbackResponse.notACard !== true || callbackResponse.isBankTransfer === true) {
    return false;
  }

  const paymentMethodId = normalizePaymentMethodId(callbackResponse.paymentMethodId);

  // Keep backward compatibility for old payloads that might omit paymentMethodId.
  if (!paymentMethodId) {
    return true;
  }

  return delayedNonCardPaymentMethodIds.has(paymentMethodId);
};

export const isPendingTerminalForResult = (
  callbackResponse?: TransactionCallbackResponse | null
): boolean => {
  if (!callbackResponse || callbackResponse.status !== PaymentStatusEnum.PENDING) {
    return false;
  }

  return isDelayedNonCardMethod(callbackResponse);
};

export const isTransitionalForResult = (
  callbackResponse?: TransactionCallbackResponse | null
): boolean => {
  if (!callbackResponse) {
    return false;
  }

  if (callbackResponse.status === PaymentStatusEnum.CREATED) {
    return true;
  }

  if (callbackResponse.status === PaymentStatusEnum.PENDING) {
    return !isPendingTerminalForResult(callbackResponse);
  }

  return false;
};

export const isTerminalSuccessForResult = (
  callbackResponse?: TransactionCallbackResponse | null
): boolean => {
  if (!callbackResponse) {
    return false;
  }

  if (callbackResponse.status === PaymentStatusEnum.SUCCESS) {
    return true;
  }

  return isPendingTerminalForResult(callbackResponse);
};

export const isTerminalFailureForResult = (
  callbackResponse?: TransactionCallbackResponse | null
): boolean => {
  return Boolean(callbackResponse && callbackResponse.status === PaymentStatusEnum.ERROR);
};
